import React from 'react';
import styles from './styles.module.css';
import pin from 'assets/images/icon_arrow_pointer.svg';
import { func, number } from 'prop-types';

LocationPin.propTypes = {
  x: number,
  y: number,
  onClick: func,
  rotate: number
};


function LocationPin(props) {

  const marker = React.useRef();

  // this ratio will change regrading in the change of the SVG
  const widthHeightRatio = 1;
  const [thisWidth, setThisWidth] = React.useState(100);
  const thisHeight = thisWidth / widthHeightRatio;
  const { onClick } = props;

  const propsForPin = {
    onClick,
    href: pin,
    transform: `translate(${props.x - thisWidth / 2}, ${props.y - thisWidth / widthHeightRatio / 2})`,
  };
   
  React.useEffect(() => {
    if (thisHeight / 2 > props.y) {
      const newWidth = props.y * 2 * widthHeightRatio;
      setThisWidth(newWidth);
    }

    if (marker.current) {
      const {value} = marker.current.attributes?.height;
      setThisWidth(value);
    }
  }, ['didMount']);

  return (
    <g {...propsForPin} >
      <path className={`${props.rotate !== 180 && 'display_none'}`} d="M85.4998 171C101.25 171 114.063 158.394 114.063 142.9C114.063 131.842 107.573 121.104 100.391 112.654C93.7446 104.835 87.1836 99.7531 86.9079 99.5409C86.0868 98.9087 84.9243 98.8988 84.0916 99.5409C83.8161 99.7531 77.255 104.835 70.6085 112.654C63.4277 121.101 56.9367 131.841 56.9367 142.9C56.9367 158.394 69.7501 171 85.4998 171ZM85.4998 132.06C92.7606 132.06 98.666 137.87 98.666 145.013C98.666 152.156 92.7606 157.966 85.4998 157.966C78.2391 157.966 72.3337 152.156 72.3337 145.013C72.3337 137.87 78.2391 132.06 85.4998 132.06Z" fill="#B60081" />
      <path className={`${props.rotate !== 270 && 'display_none'}`} d="M171 85.4999C171 69.7502 158.394 56.9368 142.9 56.9368C131.842 56.9368 121.104 63.4263 112.654 70.6085C104.835 77.2552 99.7531 83.8162 99.5409 84.0919C98.9087 84.913 98.8988 86.0754 99.5409 86.9082C99.7531 87.1837 104.835 93.7447 112.654 100.391C121.101 107.572 131.841 114.063 142.9 114.063C158.394 114.063 171 101.25 171 85.4999ZM132.06 85.4999C132.06 78.2392 137.87 72.3337 145.013 72.3337C152.156 72.3337 157.966 78.2392 157.966 85.4999C157.966 92.7607 152.156 98.6661 145.013 98.6661C137.87 98.6661 132.06 92.7607 132.06 85.4999Z" fill="#B60081" />
      <path className={`${props.rotate !== 90 && 'display_none'}`} d="M0 85.5001C0 101.25 12.6058 114.063 28.1002 114.063C39.1578 114.063 49.8965 107.574 58.3461 100.391C66.165 93.7448 71.2469 87.1838 71.4591 86.9081C72.0913 86.087 72.1012 84.9246 71.4591 84.0918C71.2469 83.8163 66.165 77.2553 58.3461 70.6087C49.8992 63.4279 39.1592 56.9369 28.1002 56.9369C12.6058 56.9369 0 69.7504 0 85.5001ZM38.94 85.5001C38.94 92.7608 33.1303 98.6663 25.9872 98.6663C18.8441 98.6663 13.0343 92.7608 13.0343 85.5001C13.0343 78.2393 18.8441 72.3339 25.9872 72.3339C33.1303 72.3339 38.94 78.2393 38.94 85.5001Z" fill="#B60081" />
      <path className={`${!!props.rotate && 'display_none'}`} d="M85.5002 0C69.7504 0 56.937 12.6058 56.937 28.1002C56.937 39.1578 63.4266 49.8965 70.6088 58.3461C77.2554 66.165 83.8164 71.2469 84.0921 71.4591C84.9132 72.0913 86.0757 72.1012 86.9084 71.4591C87.1839 71.2469 93.745 66.165 100.392 58.3461C107.572 49.8992 114.063 39.1592 114.063 28.1002C114.063 12.6058 101.25 0 85.5002 0ZM85.5002 38.94C78.2394 38.94 72.334 33.1303 72.334 25.9872C72.334 18.8441 78.2394 13.0343 85.5002 13.0343C92.7609 13.0343 98.6663 18.8441 98.6663 25.9872C98.6663 33.1303 92.7609 38.94 85.5002 38.94Z" fill="#B60081" />
      <rect width="171" height="171" fill="#C4C4C4" fillOpacity="0.04" ref={marker} />
    </g>
  )
}

export default LocationPin;